import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NotificationService } from '../shared/services/notification.service';
import { showError } from '../shared/utils/functions/notification.function';
import { descryptValue, encryptStorage } from '../auth/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class ApiKeysInterceptor implements HttpInterceptor {

  constructor(private router: Router, private notification: NotificationService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = encryptStorage.getItem('@authorization');

    let setHeaders = {};
    let url = req.url;

    if (url.includes('{url-dpge}')) {
      url = url.replace('{url-dpge}', environment.apiConnectDpgeURL);
    } else {
      url = environment.apiConnectURL + url;
    };

    const cloned = req.clone({
      headers: req.headers.set("Authorization", token ? token : ""),
      setHeaders,
      url,
    });


    return next.handle(cloned).pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (this.ignoraErro(err)) {
      return of(err.message);
    }
    //handle your auth error or rethrow
    if (err.status == 401) {
      //navigate /delete cookies or whatever
      this.router.navigateByUrl(`/autenticacao/signin`);
      showError('',"O seu token de acesso expirou, por favor faça login novamente.")
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message); // or EMPTY may be appropriate here
    } else if (err.status == 403) {
      // console.log(err)
      this.router.navigateByUrl(`/home`);
      showError('',"O Seu usuário não possuí Permissões para acessar essa funcionalidade, contate seu administrador.")
      // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
      return of(err.message); // or EMPTY may be appropriate here
    }
    return throwError(err);
  }

  ignoraErro(err: HttpErrorResponse): boolean {
    const url = err.url;
    const urlsIgnoradas = [
      `${environment.apiConnectURL}/unauthenticated/api/monitoramento/app/logs`,
      `${environment.apiConnectURL}/api/monitoramento/app/logs`,
    ];
    return urlsIgnoradas.some(u => url.includes(u));
  }
}
